module.exports = __webpack_public_path__ + "static/media/live-poker.aa1e0581.svg";